var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3 custom-bg mt-3" },
    [
      _c("validation-observer", {
        ref: "addProviderObserver",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ validate, reset }) {
              return [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 my-3" }, [
                    _c("h5", [
                      _c("strong", { staticClass: "fon" }, [
                        _vm._v("Añadir Contratista")
                      ])
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-12 my-3" },
                    [
                      _vm.isValidSsn
                        ? _c("custom-input", {
                            attrs: {
                              disabled: true,
                              label: "SSN:",
                              value: _vm.maskSSN(_vm.model.socialSecurityNo)
                            }
                          })
                        : _c("custom-input", {
                            attrs: {
                              "mask-type": "SSNPatronal",
                              placeholder: "SSN"
                            },
                            model: {
                              value: _vm.model.socialSecurityNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "socialSecurityNo", $$v)
                              },
                              expression: "model.socialSecurityNo"
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mb-3" },
                    [
                      _c("section-title", {
                        staticClass: "section-title__extended mt-4",
                        attrs: { content: "Datos de Contratista" }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-12 mb-3" }, [
                    _c("i", { staticClass: "fas fa-info-circle text-orange" }),
                    _c("strong", { staticClass: "ml-2" }, [
                      _vm._v(" Datos del Representante ")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Nombre:"
                                    },
                                    model: {
                                      value: _vm.model.representative,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "representative",
                                          $$v
                                        )
                                      },
                                      expression: "model.representative"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-1" },
                    [
                      _c("custom-input", {
                        attrs: { label: "Inicial:" },
                        model: {
                          value: _vm.model.providerMiddleInitial,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "providerMiddleInitial", $$v)
                          },
                          expression: "model.providerMiddleInitial"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Apellido Paterno:"
                                    },
                                    model: {
                                      value: _vm.model.providerPaternalLastName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "providerPaternalLastName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.providerPaternalLastName"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("custom-input", {
                        attrs: { label: "Apellido Materno:" },
                        model: {
                          value: _vm.model.providerMaternalLastName,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "providerMaternalLastName", $$v)
                          },
                          expression: "model.providerMaternalLastName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-12 my-3" }, [
                    _c("i", { staticClass: "fas fa-info-circle text-orange" }),
                    _c("strong", { staticClass: "ml-2" }, [
                      _vm._v(" Datos del Proveedor ")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Proveedor:"
                                    },
                                    model: {
                                      value: _vm.model.providerName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "providerName", $$v)
                                      },
                                      expression: "model.providerName"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required|min:10" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "Ingrese un número de teléfono válido.",
                                      error: errors[0],
                                      label: "Número de Teléfono:",
                                      "mask-type": "Phone"
                                    },
                                    model: {
                                      value: _vm.model.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "phone", $$v)
                                      },
                                      expression: "model.phone"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("validation-provider", {
                        attrs: {
                          "custom-messages": {
                            required: "El campo es requerido.",
                            email: "El correo electrónico no es válido."
                          },
                          rules: "required|email"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      error: errors[0],
                                      label: "Correo Electrónico:"
                                    },
                                    model: {
                                      value: _vm.model.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "email", $$v)
                                      },
                                      expression: "model.email"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 my-3" },
                    [
                      _c("section-title", {
                        staticClass: "section-title__extended mt-4",
                        attrs: { content: "Datos de Dirección" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Dirección (Línea 1)"
                                    },
                                    model: {
                                      value: _vm.model.addressLine1,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "addressLine1", $$v)
                                      },
                                      expression: "model.addressLine1"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("custom-input", {
                        attrs: { label: "Dirección (Línea 2)" },
                        model: {
                          value: _vm.model.addressLine2,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "addressLine2", $$v)
                          },
                          expression: "model.addressLine2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      id: "participantType",
                                      clearable: true,
                                      "custom-error-msg":
                                        "El campo es requerido",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "País",
                                      options: _vm.countries
                                    },
                                    on: { input: _vm.onCountryChange },
                                    model: {
                                      value: _vm.model.country,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "country", $$v)
                                      },
                                      expression: "model.country"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _vm.isUSA
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: "participantType",
                                          clearable: true,
                                          "custom-error-msg":
                                            "El campo es requerido",
                                          error: errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label: "Estado",
                                          options: _vm.states
                                        },
                                        on: { input: _vm.onStateChange },
                                        model: {
                                          value: _vm.model.state,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "state", $$v)
                                          },
                                          expression: "model.state"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isPuertoRico
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-drop-down", {
                                        attrs: {
                                          id: "participantType",
                                          clearable: true,
                                          "custom-error-msg":
                                            "El campo es requerido",
                                          error: errors[0],
                                          fieldkey: "id",
                                          fieldname: "name",
                                          label: "Municipio",
                                          options: _vm.municipalities
                                        },
                                        model: {
                                          value: _vm.model.municipality,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "municipality",
                                              $$v
                                            )
                                          },
                                          expression: "model.municipality"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido",
                                      error: errors[0],
                                      label: "Código Postal",
                                      "mask-type": "ZipcodeExt"
                                    },
                                    model: {
                                      value: _vm.model.postalCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "postalCode", $$v)
                                      },
                                      expression: "model.postalCode"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 d-flex justify-content-end my-3" },
                    [
                      _c("action-button", {
                        staticClass: "mr-2 px-3",
                        attrs: {
                          i: "fas fa-times-circle",
                          text: "Cancelar",
                          variant: "outline-danger"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onCancel(reset)
                          }
                        }
                      }),
                      _c("action-button", {
                        staticClass: "mr-2 px-3",
                        attrs: {
                          i: "fas fa-file-plus",
                          text: "Añadir",
                          variant: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onSubmit(validate, reset)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }